
define(
	'Tavanoteam.Calculator.Calculator'
	, [
		'Calculator.Main.View',
		'Calculator.Selant.View',
		'Calculator.Coatings.View',
		'Calculator.SquareFoot.View',
		'Calculator.CubicFoot.View'
	]
	, function (
		CalculatorMainView,
		CalculatorSealantView,
		CalculatorCoatingsView,
		CalculatorSquareFootView,
		CalculatorCubicFootView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layoutComponent = container.getComponent('Layout');
				var pageTypeComponent = container.getComponent('PageType');

				if (layoutComponent) {
					layoutComponent.registerView('CalculatorTool', function () {
						return new CalculatorMainView({ container: container });
					});
				}

				/**Main Calculator Tool Page - NOT BEING USED
				var pageType = {
					name: 'calculator_tools_landing_page',
					routes: ['tools'],
					view: CalculatorMainView,
					options: { container: container },
					defaultTemplate: {
						name: 'calculator_main.tpl',
						displayName: 'Calculator Tools'
					}
				}
				pageTypeComponent.registerPageType(pageType);
				**/

				//Sealant Calculator Tool Page
				var pageType_sealant = {
					name: 'calculator_tools_sealant_landing_page',
					routes: ['tools/sealant-calc'],
					view: CalculatorSealantView,
					options: { 
						container: container,
						isMainPage: true
					},
					defaultTemplate: {
						name: 'calculator_sealant.tpl',
						displayName: 'Sealant Calculator Tool'
					}
				}
				pageTypeComponent.registerPageType(pageType_sealant);

				//Coatings Calculator Tool Page
				var pageType_coatings = {
					name: 'calculator_tools_coatings_landing_page',
					routes: ['tools/coatings-calc'],
					view: CalculatorCoatingsView,
					options: { 
						container: container,
						isMainPage: true
					},
					defaultTemplate: {
						name: 'calculator_coatings.tpl',
						displayName: 'Coatings Calculator Tool'
					}
				}
				pageTypeComponent.registerPageType(pageType_coatings);
				
				//Square Foot Calculator Tool Page
				var pageType_squarefoot = {
					name: 'calculator_tools_squarefoot_landing_page',
					routes: ['tools/squarefoot-calc'],
					view: CalculatorSquareFootView,
					options: { 
						container: container,
						isMainPage: true
					},
					defaultTemplate: {
						name: 'calculator_square_foot.tpl',
						displayName: 'Square Foot Calculator Tool'
					}
				}
				pageTypeComponent.registerPageType(pageType_squarefoot);

				//Cubic Foot Calculator Tool Page
				var pageType_cubicfoot = {
					name: 'calculator_tools_cubicfoot_landing_page',
					routes: ['tools/cubicfoot-calc'],
					view: CalculatorCubicFootView,
					options: { 
						container: container,
						isMainPage: true
					},
					defaultTemplate: {
						name: 'calculator_cubic_foot.tpl',
						displayName: 'Cubic Foot Calculator Tool'
					}
				}
				pageTypeComponent.registerPageType(pageType_cubicfoot);
				
			}
		};
	});
